// True Fit library injection
(function (r, e, o) {
  var w = window,
    d = document,
    t,
    s,
    x;
  w.tfcapi = t =
    w.tfcapi ||
    function () {
      t.q = t.q || [];
      t.q.push(arguments);
    };
  t("init", { storeKey: r, environment: e, ...o });
  x = d.getElementsByTagName("script")[0];
  s = d.createElement("script");
  s.type = "text/javascript";
  s.async = true;
  s.dataset.ucLoaded = true;
  s.src =
    "https://" +
    r +
    "-cdn" +
    (e === "dev" || e === "staging" ? "." + e : "") +
    ".truefitcorp.com/fitrec/global/js/tf-integration.js?storeKey=" +
    r;
  x.parentNode.insertBefore(s, x);
  // Don't change anything above this line
})("gry", "prod", { autoCalculate: true });

// Size Sampling banner in mini-cart
function tfSizeSampling() {
  const cartInfo = [];

  fetch(window.Shopify.routes.root + "cart.js")
    .then((response) => response.json())
    .then((cart) => {
      cart.items.forEach((item) => {
        const sizePosition = item.options_with_values.findIndex(
          (i) =>
            i.name.toLowerCase().includes("size") ||
            i.name.toLowerCase().includes("waist")
        );
        if (sizePosition >= 0) {
          const colorPosition = item.options_with_values.findIndex((i) =>
            i.name.toLowerCase().includes("color")
          );

          cartInfo.push({
            styleId: item.product_id.toString(),
            styleName: item.product_title,
            size: item.variant_options[sizePosition],
            color: item.variant_options[colorPosition],
          });
        }
      });

      const cartInfoColorsFiltered = cartInfo.filter(
        (currentItem, currentIndex) => {
          // Check if any other items have the same product ID and color
          const matchingColors = cartInfo.some((item, index) => {
            return (
              index !== currentIndex &&
              item.styleId === currentItem.styleId &&
              item.color === currentItem.color
            );
          });
          // If we find other colors for the product, we'll include it in True Fit
          return matchingColors;
        }
      );

      tfcapi("sizeSampling", cartInfoColorsFiltered);
    });
}

tfSizeSampling();

// Run True Fit when cart drawer updated -- item added, item changed, etc.
document.addEventListener("cart-state:changed", () => {
  tfSizeSampling();
});
